import dayjs from 'dayjs';
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

const monthsInPortuguese = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
];

const parseToPtBrMonth = (date) => {
    const month = date.get('month');
    return monthsInPortuguese[month];
}

const convertToBrazilianDate = (date) => {
    return dayjs(date).format('DD/MM/YYYY');
}

const convertBrazilianDateToObject = (date) => {
    return dayjs(date, 'DD/MM/YYYY');
}

export { parseToPtBrMonth, convertToBrazilianDate, convertBrazilianDateToObject };